import { render, staticRenderFns } from "./TipoInvestimentoTabela.vue?vue&type=template&id=4f1c5906&lang=html&"
import script from "./TipoInvestimentoTabela.vue?vue&type=script&lang=js&"
export * from "./TipoInvestimentoTabela.vue?vue&type=script&lang=js&"
import style0 from "../../shared-components/generico/CRUDGenerico.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/spa/tipo-investimento/TipoInvestimentoTabela.vue
// module id = 1535
// module chunks = 28